import React from "react";

const Scroll = ({ children, type = "y", className = "", ...props }) => {
  return <div className={"scroll " + className}>{children}</div>;
};

export default Scroll;
